import BossModel from "@/models/BossModel";
import DefaultMargin from "@/models/Agent/DefaultMargin/DefaultMargin";

export default class Type extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/type';

    /**
     *
     * @type {string}
     */
    static entity = 'productTypes';

    static PROPOSAL_ADD_TYPES = [
        'hotel',
        'tour',
        'cruise',
    ];

    static fields() {
		return {
			id: this.number(null).nullable(),
			name: this.attr(null),
			code: this.attr(null),
			is_active: this.boolean(null),
			component_name: this.attr(null),
			afas_ledger_eid: this.attr(null),
			url: this.attr(null),
            defaultMargin: this.hasOne(DefaultMargin, 'product_type_id'),
		}
	}

    static getLabel(id) {
        const item = this.query().find(id);
        return item.code + ' - ' + item.name;
    }

    getLabel() {
        return this.constructor.getLabel(this.id);
    }

    getIcon() {
        return this.constructor.getIcon(this.component_name);
    }

    static getIconByLetter(letter) {
        switch (letter) {
            case 'H' : {
                return this.getIcon('hotel')
            }
            case 'F' : {
                return this.getIcon('transfer')
            }
            case 'T' : {
                return this.getIcon('tour')
            }
            case 'M' : {
                return this.getIcon('car_rental')
            }
            case 'C' : {
                return this.getIcon('camper_rental')
            }
            default: {
                return this.getIcon()
            }
        }
    }

    static getIcon(componentName) {
        switch (componentName) {
            case 'hotel' : {
                return 'mdi-bed'
            }
            case 'transfer' : {
                return 'mdi-bus'
            }
            case 'tour' : {
                return 'mdi-earth'
            }
            case 'car_rental' : {
                return 'mdi-car'
            }
            case 'camper_rental' : {
                return 'mdi-rv-truck'
            }
            default: {
                return 'mdi-pin'
            }
        }
    }

    /**
     *
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api().limit(0).where('is_active', true).get(true);
    }

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api()
            .limit(0)
            .where('is_active', true)
            .get(true);
    }
}
